import type { PContainer, PGraphics } from '../../../engine/aliases'
import type { IFontData2 } from '../../../uiParts/fontData2'
import type { IStevieText2 } from '../../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { golfCamera } from '../golfCamera-sidecar'
import { golfLayers } from '../golfLayers-sidecar'
import { golfFonts } from './golfFonts-sidecar'
import type { IGolfUiGButton } from './golfUiGButtons'
import { golfUiGButtons } from './golfUiGButtons-sidecar'
import { golfUiGraphicsUtils } from './golfUiGraphicsUtils-sidecar'
import type { IGolfUiGSelector } from './golfUiGSelectors'
import { golfUiGSelectors } from './golfUiGSelectors-sidecar'

export interface IGolfUiCanvas {
  isOpen: boolean
  graphics: PGraphics
  texts: IStevieText2[]
  buttons: IGolfUiGButton[]
  selectors: IGolfUiGSelector[]
  targetWidth: number
  targetHeight: number
  ox: number
  oy: number
  layer: PContainer
  autoOffset: boolean
}

export function create(
  targetWidth: number,
  targetHeight: number,
  parentLayer: PContainer | null = null,
) {
  let layer = parentLayer ?? golfLayers.getLayers().uiGame
  layer = golfLayers.createExternal(layer)

  let g = golfUiGraphicsUtils.createGraphics(layer)

  let obj: IGolfUiCanvas = {
    isOpen: false,
    // panel,
    graphics: g,
    texts: [],
    buttons: [],
    selectors: [],
    targetWidth,
    targetHeight,
    ox: 0,
    oy: 0,
    layer,
    autoOffset: true,
  }

  g.setInteractive({
    cursor: 'pointer',
    hitAreaCallback: (_: any, x: number, y: number) => {
      if (!obj.isOpen) {
        return false
      }

      return (
        golfUiGButtons.hitTest(obj.buttons, x, y, false) ||
        golfUiGSelectors.hitTest(obj.selectors, x, y, true)
      )
    },
  })

  return obj
}

type Diff<T, K> = Omit<T, keyof K>
export function assign<T extends IGolfUiCanvas>(
  canv: IGolfUiCanvas,
  up: Diff<T, IGolfUiCanvas>,
) {
  return Object.assign(canv, up)
}

export function setOpen(obj: IGolfUiCanvas, isOpen: boolean) {
  obj.isOpen = isOpen
  setVisible(obj, isOpen)
}

export function setVisible(obj: IGolfUiCanvas, isVisible: boolean) {
  // goatPanels.setVisible(obj.panel, isVisible)
}

export function update(obj: IGolfUiCanvas) {
  let mp = golfCamera.getUiMousePosition()
  let l = obj.layer

  if (!l.visible) {
    return
  }
  if (!obj.isOpen) {
    return
  }

  // Adjust graphics layer

  let gb = golfCamera.getGameBounds()

  // Adjust for different resolutions
  if (obj.autoOffset) {
    let ox = (gb.width - obj.targetWidth) / 2
    let oy = (gb.height - obj.targetHeight) / 2

    if (ox > 0 && obj.targetWidth) {
      l.x = ox
    } else {
      l.x = 0
    }
    if (oy > 0 && obj.targetHeight) {
      l.y = oy
    } else {
      l.y = 0
    }
  } else {
    l.x = 0
    l.y = 0
  }

  l.x += obj.ox
  l.y += obj.oy

  let mx = mp.mx - l.x
  let my = mp.my - l.y

  golfUiGButtons.hitTest(obj.buttons, mx, my, true)
  golfUiGSelectors.hitTest(obj.selectors, mx, my, true)
  // render()
}

export function clear(obj: IGolfUiCanvas) {
  obj.texts = stevieTexts2.killBulk(obj.texts)
  obj.graphics.clear()
}

export function render(obj: IGolfUiCanvas) {
  golfUiGButtons.render(obj.graphics, obj.buttons, obj.texts, obj.layer)
  golfUiGSelectors.render(obj.graphics, obj.selectors, obj.texts, obj.layer)
}

export function addText(
  obj: IGolfUiCanvas,
  text: string,
  x: number,
  y: number,
  scale = 0.4,
) {
  let _text = stevieTexts2.create(golfFonts.get().f, x, y, obj.layer)
  stevieTexts2.setText(_text, text)
  stevieTexts2.setScale(_text, scale)

  obj.texts.push(_text)
  return _text
}

export function addText2(
  obj: IGolfUiCanvas,
  text: string,
  font: IFontData2,
  x: number,
  y: number,
  scale = 0.4,
) {
  let _text = stevieTexts2.create(font, x, y, obj.layer)
  stevieTexts2.setText(_text, text)
  stevieTexts2.setScale(_text, scale)

  obj.texts.push(_text)
  return _text
}
